module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTVRJNElpQm9aV2xuYUhROUlqRXlPQ0lnZUcxc2JuTTlJbWgwZEhBNkx5OTNkM2N1ZHpNdWIzSm5Mekl3TURBdmMzWm5JajQ4Y0dGMGFDQmtQU0pOTUNBMU5DNDROVGRvTlRRdU56azJkakU0TGpJNE5rZ3pOaTQxTXpGV01USTRTREU0TGpJMk5WWTNNeTR4TkROSU1GWTFOQzQ0TlRkNmJURXlOeTQ0TlRjdE16WXVOVGN4U0RreExqa3pOVll4TWpoSU56SXVORFUyVmpFNExqSTROa2d6Tmk0MU16UldNR2c1TVM0ek1qWnNMUzR3TURNZ01UZ3VNamcyZWlJdlBqd3ZjM1puUGc9PSI="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/size.svg
// module id = Cr4N
// module chunks = 10